import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserState } from '../store/User/UserReducer';
import { Store } from '@ngrx/store';
import { initSelectedAccountSelector } from '../store/User/UserSelector';

@Injectable({
  providedIn: 'root'
})
export class AccountSelectedGuard implements CanActivate, CanLoad {

  constructor(private readonly userStore: Store<UserState>) {
  }

  /**
   * Return true if an account is already selected.
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let selectedAccount = null;
    this.userStore.select(initSelectedAccountSelector).subscribe((acc) => {
      selectedAccount = acc;
    });
    if (selectedAccount) {
      return true;
    } else {
      return false;
    }
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let selectedAccount = null;
    this.userStore.select(initSelectedAccountSelector).subscribe((acc) => {
      selectedAccount = acc;
    });
    if (selectedAccount) {
      return true;
    } else {
      return false;
    }
  }

}
